import {date_format} from '../utils/helper';

export function formatDate(date, format) {
  if (!date) {
    return '-'
  }
  return date_format(date, format);
}

export function formatUtcTicks(ticks, format) {
  if (!ticks) {
    return '';
  }
  const t = new Date(ticks);
  const utc = new Date(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate(), t.getUTCHours(), t.getUTCMinutes(), t.getUTCSeconds());
  if (!format) {
    format = "yyyy-MM-dd hh:mm:ss";
  }
  try {
    return formatDate(utc, format);
  } catch (e) {
    return "Invalid Date";
  }
}

export function yhlThumb(url) {
  if (!url)
    return "../img/none.jpg";
  if (url === "/public/images/none.jpg") {
    url = "../img/none.jpg";
  }
  return url//.replace("/bgimg/", "/xx_bgimg/");
}



// WEBPACK FOOTER //
// ./src/filters/index.js